const ATIVO_ANALISE = {
    1: { id: '1', descricao: 'Variação Mercado' },
    2: { id: '2', descricao: 'Variação Par' },
    10: { id: '10', descricao: 'Volatilidade' },
    15: { id: '15', descricao: 'Preço Médio' },
    20: { id: '20', descricao: 'Desvio Padrão' },
    25: { id: '25', descricao: 'VaR' },
    30: { id: '30', descricao: 'Sharpe' },
    35: { id: '35', descricao: 'Beta' },
    40: { id: '40', descricao: 'T.I.R.' },
    45: { id: '45', descricao: 'Duration' },
    50: { id: '50', descricao: 'Prazo Médio' },
    55: { id: '55', descricao: 'Dividend Yield' }
};

module.exports = ATIVO_ANALISE;
